// extracted by mini-css-extract-plugin
export default {"modal_dialog":"customKeyboard_modal_dialog__YiqK8","keyboard_modal":"customKeyboard_keyboard_modal__piOp3"};